import AddNoteIcon from '../../assets/icons/add-note.svg?react'
import AddPlaylistIcon from '../../assets/icons/add-playlist.svg?react'
import AddUserIcon from '../../assets/icons/add-user.svg?react'
import AddIcon from '../../assets/icons/add.svg?react'
import AirplayIcon from '../../assets/icons/airplay.svg?react'
import ArrowCollapseInIcon from '../../assets/icons/arrow-collapse-in.svg?react'
import ArrowCollapseIcon from '../../assets/icons/arrow-collapse.svg?react'
import ArrowDownIcon from '../../assets/icons/arrow-down.svg?react'
import ArrowExpandOutIcon from '../../assets/icons/arrow-expand-out.svg?react'
import ArrowExpandIcon from '../../assets/icons/arrow-expand.svg?react'
import ArrowLeftIcon from '../../assets/icons/arrow-left.svg?react'
import ArrowRightIcon from '../../assets/icons/arrow-right.svg?react'
import ArrowUpIcon from '../../assets/icons/arrow-up.svg?react'
import ArrowsPathIcon from '../../assets/icons/arrows-path.svg?react'
import AudioIcon from '../../assets/icons/audio.svg?react'
import BookmarkIcon from '../../assets/icons/bookmark.svg?react'
import CameraIcon from '../../assets/icons/camera.svg?react'
import ChaptersIcon from '../../assets/icons/chapters.svg?react'
import ChatCollapseIcon from '../../assets/icons/chat-collapse.svg?react'
import ChatIcon from '../../assets/icons/chat.svg?react'
import ChatBubble from '../../assets/icons/chat-bubble.svg?react'
import CheckIcon from '../../assets/icons/check.svg?react'
import ChevronDownIcon from '../../assets/icons/chevron-down.svg?react'
import ChevronLeftIcon from '../../assets/icons/chevron-left.svg?react'
import ChevronRightIcon from '../../assets/icons/chevron-right.svg?react'
import ChevronUpIcon from '../../assets/icons/chevron-up.svg?react'
import ChromeCastIcon from '../../assets/icons/chromecast.svg?react'
import ClipIcon from '../../assets/icons/clip.svg?react'
import Clock from '../../assets/icons/clock.svg?react'
import ClosedCaptionsDisabledIcon from '../../assets/icons/closed-captions-disabled.svg?react'
import ClosedCaptionOnIcon from '../../assets/icons/closed-captions-on.svg?react'
import ClosedCaptionsIcon from '../../assets/icons/closed-captions.svg?react'
import CommentIcon from '../../assets/icons/comment.svg?react'
import ComputerIcon from '../../assets/icons/computer.svg?react'
import CutIcon from '../../assets/icons/cut.svg?react'
import DeviceIcon from '../../assets/icons/device.svg?react'
import DividerIcon from '../../assets/icons/divider.svg?react'
import DownloadIcon from '../../assets/icons/download.svg?react'
import DrumIcon from '../../assets/icons/drum.svg?react'
import EditIcon from '../../assets/icons/edit.svg?react'
import EpisodesIcon from '../../assets/icons/episodes.svg?react'
import EyeIcon from '../../assets/icons/eye.svg?react'
import FadeIcon from '../../assets/icons/fade.svg?react'
import FastBackwardIcon from '../../assets/icons/fast-backward.svg?react'
import FastForwardIcon from '../../assets/icons/fast-forward.svg?react'
import FlagIcon from '../../assets/icons/flag.svg?react'
import FolderSolidIcon from '../../assets/icons/folder-solid.svg?react'
import FullscreenArrowExitIcon from '../../assets/icons/fullscreen-arrow-exit.svg?react'
import FullscreenArrowIcon from '../../assets/icons/fullscreen-arrow.svg?react'
import FullscreenExitIcon from '../../assets/icons/fullscreen-exit.svg?react'
import FullscreenIcon from '../../assets/icons/fullscreen.svg?react'
import FolderIcon from '../../assets/icons/folder.svg?react'
import FolderUpIcon from '../../assets/icons/folder-up.svg?react'
import FolderAudioIcon from '../../assets/icons/folder-audio.svg?react'
import FrameIcon from '../../assets/icons/frame.svg?react'
import HeartIcon from '../../assets/icons/heart.svg?react'
import HomeIcon from '../../assets/icons/home.svg?react'
import InfoIcon from '../../assets/icons/info.svg?react'
import InformationCircleIcon from '../../assets/icons/information-circle.svg?react'
import LanguageIcon from '../../assets/icons/language.svg?react'
import LinkIcon from '../../assets/icons/link.svg?react'
import LockClosedIcon from '../../assets/icons/lock-closed.svg?react'
import LockOpenIcon from '../../assets/icons/lock-open.svg?react'
import MediaFileIcon from '../../assets/icons/media-file.svg?react'
import MenuHorizontalIcon from '../../assets/icons/menu-horizontal.svg?react'
import MenuVerticalIcon from '../../assets/icons/menu-vertical.svg?react'
import MicrophoneIcon from '../../assets/icons/microphone.svg?react'
import MobileIcon from '../../assets/icons/mobile.svg?react'
import MoonIcon from '../../assets/icons/moon.svg?react'
import MusicOffIcon from '../../assets/icons/music-off.svg?react'
import MusicIcon from '../../assets/icons/music.svg?react'
import MuteIcon from '../../assets/icons/mute.svg?react'
import NextIcon from '../../assets/icons/next.svg?react'
import NotificationIcon from '../../assets/icons/notification.svg?react'
import OdometerIcon from '../../assets/icons/odometer.svg?react'
import PlayIcon from '../../assets/icons/play.svg?react'
import PauseIcon from '../../assets/icons/pause.svg?react'
import PictureInPictureExitIcon from '../../assets/icons/picture-in-picture-exit.svg?react'
import PictureInPictureIcon from '../../assets/icons/picture-in-picture.svg?react'
import PlaybackSpeedCircleIcon from '../../assets/icons/playback-speed-circle.svg?react'
import PlaylistIcon from '../../assets/icons/playlist.svg?react'
import PreviousIcon from '../../assets/icons/previous.svg?react'
import QuestionMarkIcon from '../../assets/icons/question-mark.svg?react'
import QueueListIcon from '../../assets/icons/queue-list.svg?react'
import RadioButtonSelectedIcon from '../../assets/icons/radio-button-selected.svg?react'
import RadioButtonIcon from '../../assets/icons/radio-button.svg?react'
import RedoIcon from '../../assets/icons/redo.svg?react'
import RepeatOnIcon from '../../assets/icons/repeat-on.svg?react'
import RepeatSquareOnIcon from '../../assets/icons/repeat-square-on.svg?react'
import RepeatSquareIcon from '../../assets/icons/repeat-square.svg?react'
import RepeatIcon from '../../assets/icons/repeat.svg?react'
import ReplayIcon from '../../assets/icons/replay.svg?react'
import RotateIcon from '../../assets/icons/rotate.svg?react'
import SearchIcon from '../../assets/icons/search.svg?react'
import SeekBackward10Icon from '../../assets/icons/seek-backward-10.svg?react'
import SeekBackward15Icon from '../../assets/icons/seek-backward-15.svg?react'
import SeekBackward30Icon from '../../assets/icons/seek-backward-30.svg?react'
import SeekBackwardIcon from '../../assets/icons/seek-backward.svg?react'
import SeekForward10Icon from '../../assets/icons/seek-forward-10.svg?react'
import SeekForward15Icon from '../../assets/icons/seek-forward-15.svg?react'
import SeekForward30Icon from '../../assets/icons/seek-forward-30.svg?react'
import SeekForwardIcon from '../../assets/icons/seek-forward.svg?react'
import SendIcon from '../../assets/icons/send.svg?react'
import SettingsMenuIcon from '../../assets/icons/settings-menu.svg?react'
import SettingsSwitchIcon from '../../assets/icons/settings-switch.svg?react'
import SettingsIcon from '../../assets/icons/settings.svg?react'
import ShareArrowIcon from '../../assets/icons/share-arrow.svg?react'
import ShareIcon from '../../assets/icons/share.svg?react'
import ShuffleOnIcon from '../../assets/icons/shuffle-on.svg?react'
import ShuffleIcon from '../../assets/icons/shuffle.svg?react'
import SparklesIcon from '../../assets/icons/sparkles.svg?react'
import SpeechIcon from '../../assets/icons/speech.svg?react'
import SoundEffectIcon from '../../assets/icons/sound-effect.svg?react'
import StopIcon from '../../assets/icons/stop.svg?react'
import SubtitlesIcon from '../../assets/icons/subtitles.svg?react'
import SunIcon from '../../assets/icons/sun.svg?react'
import TextIcon from '../../assets/icons/text.svg?react'
import TheatreModeExitIcon from '../../assets/icons/theatre-mode-exit.svg?react'
import TheatreModeIcon from '../../assets/icons/theatre-mode.svg?react'
import ThumbsDownIcon from '../../assets/icons/thumbs-down.svg?react'
import ThumbsUpIcon from '../../assets/icons/thumbs-up.svg?react'
import TimerIcon from '../../assets/icons/timer.svg?react'
import TranscriptIcon from '../../assets/icons/transcript.svg?react'
import TrashIcon from '../../assets/icons/trash.svg?react'
import TvIcon from '../../assets/icons/tv.svg?react'
import UndoIcon from '../../assets/icons/undo.svg?react'
import UploadIcon from '../../assets/icons/upload.svg?react'
import UserIcon from '../../assets/icons/user.svg?react'
import VolumeHighIcon from '../../assets/icons/volume-high.svg?react'
import VolumeLowIcon from '../../assets/icons/volume-low.svg?react'
import WarningIcon from '../../assets/icons/warning.svg?react'
import XMarkIcon from '../../assets/icons/x-mark.svg?react'
import CloudOffOutlineRoundedIcon from '../../assets/icons/cloud-off-outline-rounded.svg?react'
import CloudAlertOutlineRoundedIcon from '../../assets/icons/cloud-alert-outline-rounded.svg?react'
import CloudDoneOutlineRoundedIcon from '../../assets/icons/cloud-done-outline-rounded.svg?react'
import React from 'react'

const icons = {
  addPlaylist: AddPlaylistIcon,
  addNote: AddNoteIcon,
  addUser: AddUserIcon,
  add: AddIcon,
  airplay: AirplayIcon,
  arrowCollapseIn: ArrowCollapseInIcon,
  arrowCollapse: ArrowCollapseIcon,
  arrowDown: ArrowDownIcon,
  arrowExpandOut: ArrowExpandOutIcon,
  arrowExpand: ArrowExpandIcon,
  arrowLeft: ArrowLeftIcon,
  arrowRight: ArrowRightIcon,
  arrowUp: ArrowUpIcon,
  arrowsPath: ArrowsPathIcon,
  audio: AudioIcon,
  bookmark: BookmarkIcon,
  camera: CameraIcon,
  chapters: ChaptersIcon,
  chatCollapse: ChatCollapseIcon,
  chat: ChatIcon,
  chatBubble: ChatBubble,
  check: CheckIcon,
  chevronDown: ChevronDownIcon,
  chevronLeft: ChevronLeftIcon,
  chevronRight: ChevronRightIcon,
  chevronUp: ChevronUpIcon,
  chromeCast: ChromeCastIcon,
  clip: ClipIcon,
  clock: Clock,
  cloudOffOutlineRounded: CloudOffOutlineRoundedIcon,
  cloudAlertOutlineRounded: CloudAlertOutlineRoundedIcon,
  cloudDoneOutlineRounded: CloudDoneOutlineRoundedIcon,
  closedCaptionsDisabled: ClosedCaptionsDisabledIcon,
  closedCaptionOn: ClosedCaptionOnIcon,
  closedCaptions: ClosedCaptionsIcon,
  comment: CommentIcon,
  computer: ComputerIcon,
  cut: CutIcon,
  device: DeviceIcon,
  divider: DividerIcon,
  download: DownloadIcon,
  drum: DrumIcon,
  edit: EditIcon,
  episodes: EpisodesIcon,
  eye: EyeIcon,
  fade: FadeIcon,
  fastBackward: FastBackwardIcon,
  fastForward: FastForwardIcon,
  flag: FlagIcon,
  folderSolid: FolderSolidIcon,
  folder: FolderIcon,
  folderUp: FolderUpIcon,
  folderAudio: FolderAudioIcon,
  frame: FrameIcon,
  fullscreenArrowExit: FullscreenArrowExitIcon,
  fullscreenArrow: FullscreenArrowIcon,
  fullscreenExit: FullscreenExitIcon,
  fullscreen: FullscreenIcon,
  heart: HeartIcon,
  home: HomeIcon,
  info: InfoIcon,
  informationCircle: InformationCircleIcon,
  language: LanguageIcon,
  link: LinkIcon,
  lockClosed: LockClosedIcon,
  lockOpen: LockOpenIcon,
  mediaFile: MediaFileIcon,
  menuHorizontal: MenuHorizontalIcon,
  menuVertical: MenuVerticalIcon,
  microphone: MicrophoneIcon,
  mobile: MobileIcon,
  moon: MoonIcon,
  musicOff: MusicOffIcon,
  music: MusicIcon,
  mute: MuteIcon,
  next: NextIcon,
  notification: NotificationIcon,
  odometer: OdometerIcon,
  pause: PauseIcon,
  pictureInPictureExit: PictureInPictureExitIcon,
  pictureInPicture: PictureInPictureIcon,
  play: PlayIcon,
  playbackSpeedCircle: PlaybackSpeedCircleIcon,
  playlist: PlaylistIcon,
  previous: PreviousIcon,
  questionMark: QuestionMarkIcon,
  queueList: QueueListIcon,
  radioButtonSelected: RadioButtonSelectedIcon,
  radioButton: RadioButtonIcon,
  redo: RedoIcon,
  repeatOn: RepeatOnIcon,
  repeatSquareOn: RepeatSquareOnIcon,
  repeatSquare: RepeatSquareIcon,
  repeat: RepeatIcon,
  replay: ReplayIcon,
  rotate: RotateIcon,
  search: SearchIcon,
  seekBackward10: SeekBackward10Icon,
  seekBackward15: SeekBackward15Icon,
  seekBackward30: SeekBackward30Icon,
  seekBackward: SeekBackwardIcon,
  seekForward10: SeekForward10Icon,
  seekForward15: SeekForward15Icon,
  seekForward30: SeekForward30Icon,
  seekForward: SeekForwardIcon,
  send: SendIcon,
  settingsMenu: SettingsMenuIcon,
  settingsSwitch: SettingsSwitchIcon,
  settings: SettingsIcon,
  shareArrow: ShareArrowIcon,
  share: ShareIcon,
  shuffleOn: ShuffleOnIcon,
  shuffle: ShuffleIcon,
  sparkles: SparklesIcon,
  speech: SpeechIcon,
  soundEffect: SoundEffectIcon,
  stop: StopIcon,
  subtitles: SubtitlesIcon,
  sun: SunIcon,
  text: TextIcon,
  theatreModeExit: TheatreModeExitIcon,
  theatreMode: TheatreModeIcon,
  thumbsDown: ThumbsDownIcon,
  thumbsUp: ThumbsUpIcon,
  timer: TimerIcon,
  transcript: TranscriptIcon,
  trash: TrashIcon,
  tv: TvIcon,
  undo: UndoIcon,
  upload: UploadIcon,
  user: UserIcon,
  volumeHigh: VolumeHighIcon,
  volumeLow: VolumeLowIcon,
  warning: WarningIcon,
  xMark: XMarkIcon,
}

export type IconName = keyof typeof icons

interface IconProps {
  name: IconName
  width?: number
  height?: number
  size?: number
  fill?: string
}

const Icon: React.FC<IconProps> = ({
  name,
  width = 24,
  height = 24,
  fill = '#000',
  size,
}) => {
  const SvgIcon = icons[name]

  if (!SvgIcon) {
    return null
  }

  if (size) {
    width = size
    height = size
  }

  return <SvgIcon width={width} height={height} style={{ fill }} />
}

export default React.memo(Icon)
